import { render, staticRenderFns } from "./m-editQuestionSNPMB.vue?vue&type=template&id=976e031c&"
import script from "./m-editQuestionSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-editQuestionSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports